import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppsResponse } from '@vi-succ/vi-header-domain/lib/entities';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppSwitcherService {
  constructor(private http: HttpClient) {}

  public getApps(userId: string): Observable<AppsResponse> {
    return this.http.get<AppsResponse>(environment.iam.auth.baseUrl + `/users/v1/users/${userId}/apps`);
  }
}
